import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useSendOneTSD = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tsdId: string) => {
      const result = await apiClient.tsd.sendTsd.mutation({ params: { tsdId } });
      if (result.status !== 200) throw result.body;
      return result.body.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success('Temporary storage declaration sent successfully!');
    },
    onError: (error) => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      showErrorToast(error, `Error sending the temporary storage declaration!`);
    },
  });
};
